export default __webpack_public_path__ + "static/retireds-8c35066c05f76a7e80a71a20cdb8f043.png";